import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

export const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 8px 0;
  gap: 8px;
`;

interface DotProps {
  $active: boolean;
}
export const Dot = styled.div<DotProps>`
  width: ${({ $active }) => ($active ? `${pxToRem(30)}` : `${pxToRem(15)}`)};
  height: ${({ $active }) => ($active ? `${pxToRem(30)}` : `${pxToRem(15)}`)};
  border-radius: 50%;
  background-color: white;
  
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${pxToRem(15)};
  font-family: ${({ theme }) => theme.title_font || `'Nunito', sans-serif`};
  font-weight: 900;
  align-self: center;
`